import type {AuditPlanPageStatus, ChildrenStatusSummary} from "platformed-client/types";
import type {TranslationKey} from "@tolgee/react";

/** Lifecycle order, for sorting and for rendering pickers. */
export const PLAN_PAGE_STATUSES = ["NotStarted", "InProgress", "InReview", "Complete"] as const;

export const STATUS_LABEL_KEYS: Record<AuditPlanPageStatus, TranslationKey> = {
  NotStarted: "c.Not_started",
  InProgress: "c.In_progress",
  InReview: "c.In_review",
  Complete: "c.Complete",
};

/** Chakra `colorPalette` per status, shared by status badges/indicators. */
export const STATUS_COLORS: Record<AuditPlanPageStatus, string> = {
  NotStarted: "gray",
  InProgress: "blue",
  InReview: "orange",
  Complete: "green",
};

/** Which count on a [`ChildrenStatusSummary`] each status contributes to. */
export const STATUS_SUMMARY_FIELDS: Record<AuditPlanPageStatus, keyof ChildrenStatusSummary> = {
  NotStarted: "not_started",
  InProgress: "in_progress",
  InReview: "in_review",
  Complete: "complete",
};
